import {Box, Container, Stack, Typography, useTheme} from '@mui/material'
import whyRobo from '../assets/why-robo.png'
import box1 from '../assets/box-1.png'
import box2 from '../assets/box-2.png'
import box3 from '../assets/box-3.png'
import box4 from '../assets/box-4.png'
import box5 from '../assets/box-5.png'
import {useTranslation} from 'react-i18next'

const WhyUsSection = () => {
  const theme = useTheme()
  const [t, i18n] = useTranslation()
  const isRTL = i18n.dir() === 'rtl'

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.common.black,
        marginTop: '-8px',
        position: 'relative',
        overFlow: 'hidden'
      }}
    >
      <Box
        component="img"
        src={whyRobo}
        sx={{
          width: {xs: '100%', sm: '100%', lg: 450},
          maxWidth: {xs: '100vw', sm: 400, lg: 'none'},
          marginX: 'auto',
          position: 'absolute',
          bottom: {lg: '0%'},
          left: {xs: '50%', lg: '50%'},
          transform: 'translate(-50%, 0%)',
          display: {xs: 'none', md: 'none', lg: 'block'}
        }}
      />
      <Container
        maxWidth="lg"
        sx={{
          position: 'relative',
          zIndex: 5,
          marginTop: '-8px',
          paddingY: {xs: '80px', sm: '100px', md: '50px'},
          paddingX: '20px'
        }}
      >
        <Box
          component="div"
          sx={{
            display: 'flex',
            flexDirection: {xs: 'column', md: 'row'},
            justifyContent: 'space-between',
            gap: '64px',
            maxWidth: {sm: '80%', md: 'none'},
            marginX: {sm: 'auto', md: 'none'}
          }}
        >
          <Typography
            sx={{
              position: {xs: 'static', md: 'absolute'},
              top: {md: '8%'},
              right: {md: '5%'},
              textAlign: {xs: 'center', md: 'right'},
              color: theme.palette.common.white,
              fontFamily: 'Share, Varela Round',
              fontSize: {xs: '36px', sm: '48px', md: '60px'},
              lineHeight: 1,
              fontWeight: 400,
              marginBottom: {xs: '30px', md: 0}
            }}
          >
            {t('fnd-home-whyus-title-1')}
            <br />
            {t('fnd-home-whyus-title-2')}
          </Typography>

          <Stack
            direction="column"
            spacing={{xs: 7, lg: 8}}
            sx={{maxWidth: {lg: '40%'}}}
          >
            {/* Box 1 */}
            <Box
              component="div"
              sx={{
                height: 182,
                position: 'relative',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Helios',
                  fontSize: {xs: 60, md: 70, lg: 80},
                  color: '#61F1FD',
                  textShadow: `0 0 20px ${theme.palette.primary.light}`,
                  position: 'absolute',
                  top: {xs: '2%', xl: '3%'},
                  left: isRTL ? 'auto' : '5%',
                  right: isRTL ? '15%' : 'auto',
                  transform: isRTL
                    ? 'translate(50%, -50%) rotate(10deg)'
                    : 'translate(-50%, -50%) rotate(-10deg)'
                }}
              >
                1
              </Typography>
              <Box
                sx={{
                  position: 'relative',
                  maxWidth: {xs: '80%'},
                  marginRight: 'auto',
                  zIndex: 1,
                  color: theme.palette.common.white,
                  paddingLeft: {xs: 2.5, lg: 4}
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: {xs: '16px', md: '18px'},
                    color: theme.palette.common.white,
                    marginBottom: 1
                  }}
                >
                  {t('fnd-home-whyus-box-1-title')}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: {xs: '14px', md: '16px'},
                    color: theme.palette.common.white
                  }}
                >
                  {t('fnd-home-whyus-box-1-subtitle')}
                </Typography>
              </Box>
              <Box
                component="img"
                src={box1}
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  zIndex: -1,
                  height: '100%',
                  width: '100%',
                  transform: isRTL ? 'scaleX(-1) scaleY(-1)' : 'none'
                }}
              />
            </Box>
            {/* Box 2 */}
            <Box
              component="div"
              sx={{
                height: 182,
                position: 'relative',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Helios',
                  fontSize: {xs: 60, md: 70, lg: 80},
                  color: '#61F1FD',
                  textShadow: `0 0 20px ${theme.palette.primary.light}`,
                  position: 'absolute',
                  top: {xs: '2%', xl: '3%'},
                  left: isRTL ? '5%' : 'auto',
                  right: isRTL ? 'auto' : '5%',
                  transform: isRTL
                    ? 'translate(50%, -50%) rotate(-10deg)'
                    : 'translate(-50%, -50%) rotate(10deg)'
                }}
              >
                2
              </Typography>
              <Box
                sx={{
                  position: 'relative',
                  maxWidth: {xs: '80%'},
                  marginLeft: 'auto',
                  marginRight: '8%',
                  zIndex: 1,
                  color: theme.palette.common.white,
                  paddingLeft: {xs: 2.5, lg: 4}
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: {xs: '16px', md: '18px'},
                    color: theme.palette.common.white,
                    marginBottom: 1,
                    textAlign: 'right'
                  }}
                >
                  {t('fnd-home-whyus-box-2-title')}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: {xs: '14px', md: '16px'},
                    color: theme.palette.common.white,
                    textAlign: 'right'
                  }}
                >
                  {t('fnd-home-whyus-box-2-subtitle')}
                </Typography>
              </Box>
              <Box
                component="img"
                src={box2}
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  zIndex: -1,
                  height: '100%',
                  width: '100%',
                  transform: isRTL ? 'scaleX(-1) scaleY(-1)' : 'none'
                }}
              />
            </Box>
            {/* Box 3 */}
            <Box
              component="div"
              sx={{
                height: 182,
                position: 'relative',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Helios',
                  fontSize: {xs: 60, md: 70, lg: 80},
                  color: '#61F1FD',
                  textShadow: `0 0 20px ${theme.palette.primary.light}`,
                  position: 'absolute',
                  top: {xs: '2%', xl: '3%'},
                  left: isRTL ? 'auto' : '10%',
                  right: isRTL ? '15%' : 'auto',
                  transform: isRTL
                    ? 'translate(50%, -50%) rotate(10deg)'
                    : 'translate(-50%, -50%) rotate(-10deg)'
                }}
              >
                3
              </Typography>
              <Box
                sx={{
                  position: 'relative',
                  maxWidth: {xs: '80%'},
                  marginRight: 'auto',
                  zIndex: 1,
                  color: theme.palette.common.white,
                  paddingLeft: {xs: 2.5, lg: 4}
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: {xs: '16px', md: '18px'},
                    color: theme.palette.common.white,
                    marginBottom: 1
                  }}
                >
                  {t('fnd-home-whyus-box-3-title')}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: {xs: '14px', md: '16px'},
                    color: theme.palette.common.white
                  }}
                >
                  {t('fnd-home-whyus-box-3-subtitle')}
                </Typography>
              </Box>
              <Box
                component="img"
                src={box3}
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  zIndex: -1,
                  height: '100%',
                  width: '100%',
                  transform: isRTL ? 'scaleX(-1) scaleY(-1)' : 'none'
                }}
              />
            </Box>
          </Stack>

          <Stack
            direction="column"
            justifyContent="end"
            spacing={{xs: 8, lg: 12}}
            sx={{maxWidth: {lg: '40%'}}}
          >
            {/* Box 4 */}
            <Box
              component="div"
              sx={{
                height: 182,
                position: 'relative',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Helios',
                  fontSize: {xs: 60, md: 70, lg: 80},
                  color: '#61F1FD',
                  textShadow: `0 0 20px ${theme.palette.primary.light}`,
                  position: 'absolute',
                  top: isRTL ? '2%' : '8%',
                  left: isRTL ? '5%' : 'auto',
                  right: isRTL ? 'auto' : '5%',
                  transform: isRTL
                    ? 'translate(50%, -50%) rotate(-10deg)'
                    : 'translate(-50%, -50%) rotate(10deg)'
                }}
              >
                4
              </Typography>
              <Box
                sx={{
                  position: 'relative',
                  maxWidth: {xs: '100%', md: '90%'},
                  marginLeft: 'auto',
                  marginRight: '8%',
                  zIndex: 1,
                  color: theme.palette.common.white,
                  paddingLeft: {xs: 2.5, lg: 4}
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: {xs: '16px', md: '18px'},
                    color: theme.palette.common.white,
                    marginBottom: 1,
                    textAlign: 'right'
                  }}
                >
                  {t('fnd-home-whyus-box-4-title')}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: {xs: '14px', md: '16px'},
                    color: theme.palette.common.white,
                    textAlign: 'right'
                  }}
                >
                  {t('fnd-home-whyus-box-4-subtitle')}
                </Typography>
              </Box>
              <Box
                component="img"
                src={box4}
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  zIndex: -1,
                  height: '100%',
                  width: '100%',
                  transform: isRTL ? 'scaleX(-1) scaleY(-1)' : 'none'
                }}
              />
            </Box>
            {/* Box 5 */}
            <Box
              component="div"
              sx={{
                height: 182,
                position: 'relative',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Helios',
                  fontSize: {xs: 60, md: 70, lg: 80},
                  color: '#61F1FD',
                  textShadow: `0 0 20px ${theme.palette.primary.light}`,
                  position: 'absolute',
                  top: {xs: '2%', xl: '3%'},
                  left: isRTL ? 'auto' : '10%',
                  right: isRTL ? '15%' : 'auto',
                  transform: isRTL
                    ? 'translate(50%, -50%) rotate(10deg)'
                    : 'translate(-50%, -50%) rotate(-10deg)'
                }}
              >
                5
              </Typography>
              <Box
                sx={{
                  position: 'relative',
                  maxWidth: {xs: '80%'},
                  marginRight: 'auto',
                  zIndex: 1,
                  color: theme.palette.common.white,
                  paddingLeft: {xs: 2.5, lg: 4}
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: {xs: '16px', md: '18px'},
                    color: theme.palette.common.white,
                    marginBottom: 1
                  }}
                >
                  {t('fnd-home-whyus-box-5-title')}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: {xs: '14px', md: '16px'},
                    color: theme.palette.common.white
                  }}
                >
                  {t('fnd-home-whyus-box-5-subtitle')}
                </Typography>
              </Box>
              <Box
                component="img"
                src={box5}
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  zIndex: -1,
                  height: '100%',
                  width: '100%',
                  transform: isRTL ? 'scaleX(-1) scaleY(-1)' : 'none'
                }}
              />
            </Box>
          </Stack>
        </Box>
      </Container>

      {/* Blur circles */}
      <Box
        component="div"
        sx={{
          position: 'absolute',
          top: {xs: '45%', sm: '40%', md: '35%', lg: '10%'},
          left: {xs: '-30%', sm: '-10%', lg: '-15%'},
          width: {xs: 250, sm: 300, lg: 500},
          aspectRatio: '1/1',
          height: 'auto',
          borderRadius: '50%',
          backgroundColor: theme.palette.primary.main,
          filter: 'blur(150px)',
          zIndex: 1
        }}
      />
      <Box
        component="div"
        sx={{
          position: 'absolute',
          top: {xs: '60%', sm: '50%', lg: '30%'},
          right: {xs: '0%', sm: '0%', lg: '0%'},
          width: {xs: '20%', sm: '15%', lg: '18%'},
          height: 'auto',
          aspectRatio: '1 / 1',
          borderRadius: '50%',
          backgroundColor: theme.palette.primary.main,
          filter: 'blur(150px)',
          zIndex: 1
        }}
      />
    </Box>
  )
}

export default WhyUsSection
